import styled from 'styled-components'

export const LoginContainer = styled.div`
  user-select: none;
  color: ${props => props.theme.palette.general.greyDark};
  transform: translateY(-1em);

  button {
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: ${props => props.theme.palette.primary.alpha};
  }
`
